import { ReactElement } from 'react';

import Image from './Image';
import ImageLinkBlock from '../UI/ImageLinkBlock';
import { PhotoBlockProps } from 'components/Contentful/PhotoGallery';

interface PhotoGalleryBlockProps extends PhotoBlockProps {
  width: number;
  query?: string;
  fullWidth?: boolean;
}

export default function PhotoGalleryBlock({
  image,
  rowOneText,
  rowTwoText,
  rowThreeText,
  link,
  openInNewTab,
  width,
  query = '',
  fullWidth = false,
}: PhotoGalleryBlockProps): ReactElement {
  const widthClass = fullWidth ? 'w-full' : `w-1/2 lg:w-1/${width}`;
  return (
    <div className={`${widthClass} border-transparent mb-4 border-8 lg:mb-6 `}>
      <div className="overflow-hidden">
        {link ? (
          <ImageLinkBlock
            image={image}
            imageQuery={query}
            openInNewTab={openInNewTab || false}
            classNames="block h-full w-full object-cover"
            link={link}
            id="id"
          />
        ) : (
          <Image image={image} query={query} classNames="block h-full w-full object-cover" />
        )}
      </div>
      {(rowOneText || rowTwoText || rowThreeText) && (
        <div className="mt-4 text-sm lg:text-lg">
          {rowOneText && <span className="block font-bold">{rowOneText}</span>}
          {rowTwoText && <span className="block">{rowTwoText}</span>}
          {rowThreeText && <span className="block">{rowThreeText}</span>}
        </div>
      )}
    </div>
  );
}
